import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const FinalCTASection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-20 bg-gradient-hero">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
          🚀 Pronto para transformar seu marketing?
        </h2>
        
        <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
          Tudo que você precisa para vender online — em um único lugar.
        </p>

        <div className="flex justify-center">
          <Button               
            variant="cta" 
            size="lg"
            onClick={() => navigate('/auth')}
            className="group text-lg px-8 py-6 h-auto"
          >
            👉 Quero Começar Agora
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;